import React, { useState, useEffect } from 'react';

import { Alert } from 'reactstrap';

import agent from '../../agent';
import LoadingSpinner from '../common/LoadingSpinner';
import { EmployerPublicViewType } from '../../types/services-api';
import OfficeMap from '../profile/offices/OfficeMap';
import OfficesList from '../profile/offices/OfficesList';

function isPublicEmployer(obj: any): obj is EmployerPublicViewType {
  return !!obj && 'email' in obj;
}
const PublicEmployerPage = (props) => {
  const [employer, setEmployer] = useState<EmployerPublicViewType | null>(null);
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    if (props.employer) {
      fetchEmployer();
    }
  }, [props.employer]);

  function fetchEmployer() {
    setEmployer(null);
    setErrorMessage('');

    agent.User.getEmployer({ employer: props.employer })
      .then((res) => {
        setEmployer(res.data);
      })
      .catch((err) => {
        if (err.data.error.code === 404) {
          setErrorMessage('This employer is no longer available');
        } else {
          setErrorMessage(err.message);
        }
      });
  }

  if (isPublicEmployer(employer)) {
    return (
      <>
        <Alert isOpen={!!errorMessage} color="danger" className="my-3">
          {errorMessage}
        </Alert>
        <h3 className="my-4">{employer.name}</h3>
        <p
          className="dp-text-pre-wrap"
          dangerouslySetInnerHTML={{ __html: employer.about }}
        ></p>
        <hr />
        <p className="mb-0 lead">{employer.offices.length} Office Locations</p>

        <div className="d-flex flex-wrap">
          <div className="col-12 px-1 py-3 rounded">
            <OfficeMap publicList={employer.offices} />
          </div>
          <div className="col-12 px-1 mx-auto">
            {employer.offices.length >= 1 && (
              <OfficesList publicList={employer.offices} />
            )}
          </div>
        </div>
      </>
    );
  } else {
    return <LoadingSpinner />;
  }
};
export default PublicEmployerPage;
